/**
 * OCS roaming setting names for the classic Outlook (Win32) style state. Registered server-side in
 * server-ows-api `registeredSettings.json` as GLOBAL RoamingSettings.
 */
export const WIN32_STYLE_ENABLED_SETTING_NAME = 'win32style_enabled';
export const WIN32_STYLE_THEME_ID_SETTING_NAME = 'win32style_themeid';
export const NON_WIN32_STYLE_THEME_ID_SETTING_NAME = 'non_win32style_themeid';
